import React from "react";
import SEO from "./SEO";

const PHONES = [
	{value: '0 (507) 809 89 89', href: 'tel:05078098989'},
	{value: '0 (505) 809 89 89', href: 'tel:05058098989'},
	{value: '0 (541) 809 89 89', href: 'tel:05418098989'},
];

const MAP_SRC =
	'https://www.google.com/maps/embed?pb=!4v1777723975591!6m8!1m7!1smX0x7CbOUZ7JZNrrZYRO6g!2m2!1d40.98690179912337!2d28.78007963949387!3f243.48195654979233!4f-2.1144641583182846!5f0.7820865974627469';

const DIRECTIONS_URL =
	'https://www.google.com/maps/dir/?api=1&destination=Barbaros+Caddesi+No+17+K%C3%BC%C3%A7%C3%BCk%C3%A7ekmece+%C4%B0stanbul';

const Contact = () => {
	return (
		<section className='contact'>
			<SEO
				title="İletişim — Küçükçekmece Ofisimiz · Proteam Yönetim"
				description="Barbaros Caddesi No:17, Küçükçekmece / İstanbul. Site ve apartman yönetimi için danışmanlık ve teklif almak üzere bize ulaşın."
				path="/iletisim"
			/>
			<div className='contact-inner'>
				<div className='contact-header'>
					<span className='section-eyebrow'>İletişim</span>
					<h1 className='section-title'>Bize ulaşın</h1>
					<p className='section-lead'>
						Site ve apartman yönetimi için danışmanlık, teklif veya iş
						birliği talepleriniz için ofisimizden bize ulaşabilirsiniz.
					</p>
				</div>

				<article className='contact-card'>
					<div className='contact-card-info'>
						<span className='branch-tag'>Ofis</span>
						<h3>Küçükçekmece — İstanbul</h3>
						<address>
							Barbaros Caddesi No: 17
							<br/>Küçükçekmece / İstanbul
						</address>

						<ul className='contact-list'>
							{PHONES.map((p) => (
								<li key={p.value}>
									<a href={p.href}>
										<i className='fa fa-phone' aria-hidden='true'></i>
										<span>{p.value}</span>
									</a>
								</li>
							))}
							<li>
								<a href='mailto:info@proteamyonetim.com'>
									<i className='fa fa-envelope-o' aria-hidden='true'></i>
									<span>info@proteamyonetim.com</span>
								</a>
							</li>
						</ul>

						<a
							href={DIRECTIONS_URL}
							target='_blank'
							rel='noopener noreferrer'
							className='btn btn-primary directions-btn'
						>
							<i className='fa fa-map-marker' aria-hidden='true'></i>
							Yol tarifi al
						</a>
					</div>
					<div className='contact-card-map'>
						<iframe
							title='Proteam Yönetim — Ofis Konumu'
							src={MAP_SRC}
							loading='lazy'
							referrerPolicy='no-referrer-when-downgrade'
							allowFullScreen=''
						/>
					</div>
				</article>
			</div>
		</section>
	);
};

export default Contact;
